<template>
    <!-- 员工管理 -->
    <div class="main-container">
        <div class="top">
            <Button type="primary" ghost @click="back('/orderManage/testManagement')">返回</Button>
        </div>
        <Form ref="formInline" class="page-form detail" :model="formData" :label-width="80">
            <FormItem label="考核类型">
                <div>{{ formData.checkType == '1' ? '晋升' : '维持' }}</div>
            </FormItem>
            <FormItem label="基本法">
                <div>{{ formData.baseMethodName }}</div>
            </FormItem>
            <FormItem label="考核职级">
                <div>{{ formData.rankName }}</div>
            </FormItem>
            <FormItem label="考核时间">
                <div>{{ formData.accountDate }}</div>
            </FormItem>
            <FormItem label="业务员">
                <div>{{ formData.userName }}</div>
            </FormItem>
            <FormItem label="所属组织">
                <div>{{ formData.organizationName }}/{{ formData.groupName }}</div>
            </FormItem>
            <FormItem label="入职日期">
                <div>{{ formData.entryTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="入职天数">
                <div>{{ formData.entryDays }}</div>
            </FormItem>
        </Form>
        <div class="content">
            <list v-for="(item, index) in tableData" :key="index" :dataInfo="item" ref="list"></list>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import list from './components/list';
import riseModal from './components/riseModal';
import { pageTool, common } from '@/api/mixins';
export default {
    mixins: [pageTool, common],
    components: {
        list,
        riseModal
    },
    props: {},
    data() {
        return {
            formData: {},
            id: '',
            tabList: [],
            searchParams: {},
            columnsKey: ['rankRecommendCounts'],
            columns1Key: ['rankFirstYearCommission'],
            tableData: []
        };
    },
    created() {
        this.searchParams.id = this.$route.query.id;
        this.getDetail();
    },
    methods: {
        getDetail() {
            this.$http({
                url: '/buz/userPromotionRecord/queryDetailInfo',
                type: 'GET',
                data: this.searchParams
            }).then(res => {
                this.formData = res.data;
                this.tableData = res.data.detailIds.map(item => {
                    return { detailId: item.id, userId: this.$route.query.userId, detailCode: item.detailCode };
                });
                if (this.tableData.length) {
                    this.$nextTick(() => {
                        this.tableData.forEach((i, index) => {
                            this.$refs.list[index].init(i);
                        })
                    });
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.top{
    text-align: right;
}
.detail {
    margin-bottom: 40px;
}

.table-box {

    .close,
    .opening {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 4px;
    }

    .close {
        background: #e36767;
    }

    .opening {
        background: #35bf3f;
    }
}

/deep/ .input-item {
    width: 30%;
}

.wrapper .content {
    .search-box {
        .label {
            min-width: 80px;
        }
    }
}

.tableBox {
    .disabled {
        color: #999;
        cursor: default;
    }
}

.descLine {
    span {
        margin-right: 30px;
    }
}

/deep/ .ivu-modal-body {
    padding: 16px 30px;
}
</style>
